"use client"

import { useState } from "react"
import { TOKENOMICS_DISTRIBUTION } from "@/lib/dapp-content"
import { ReactorCoreStage } from "@/components/reactor/reactor-core-stage"
import { TokenomicsLiveMetrics } from "@/components/tokenomics/tokenomics-live-metrics"

type Row = (typeof TOKENOMICS_DISTRIBUTION)[number]

export type TokenomicsViewProps = {
  convexUrl?: string
}

export function TokenomicsView({ convexUrl = "" }: TokenomicsViewProps) {
  const [active, setActive] = useState<number | null>(null)

  return (
    <div className="tk-wrap">
      <div className="tk-live-span">
        <TokenomicsLiveMetrics convexUrl={convexUrl} />
      </div>
      <div className="tk-left">
        <h2>
          Tokenomics <span className="accent">/_Reactor</span>
        </h2>
        <p className="sub">// Total supply 1,000,000,000 RIVYU · Live splits from protocol model · Hover_to_inspect_</p>
        <ReactorCoreStage active={active} setActive={setActive} />
      </div>
      <div className="tk-right">
        <div className="tk-right-head">
          <span>// ALLOCATION_TABLE</span>
          <span style={{ color: "var(--green-bright)" }}>{TOKENOMICS_DISTRIBUTION.length} TRANCHES</span>
        </div>
        {TOKENOMICS_DISTRIBUTION.map((t: Row, i) => (
          <div
            key={t.name}
            className={`tk-bar-row ${i === active ? "active" : ""}`}
            onMouseEnter={() => setActive(i)}
            onMouseLeave={() => setActive(null)}
          >
            <span className="idx">{String(i + 1).padStart(2, "0")}</span>
            <div className="lbl">
              <span className="name">{t.name}</span>
              <span className="desc">{t.description}</span>
              <div className="gauge">
                <div className="fill" style={{ width: `${(t.value / 30) * 100}%` }} />
              </div>
            </div>
            <div className="pct" style={{ color: i === active ? "var(--cyan)" : "var(--green-bright)" }}>
              {t.value}
              <span style={{ fontSize: 14 }}>%</span>
              <span className="small">{t.tokens}</span>
            </div>
          </div>
        ))}
        <div className="tk-total-foot">
          <span>◆ TOTAL</span>
          <span style={{ color: "var(--green-bright)" }}>100% · 1,000,000,000 RIVYU</span>
        </div>
      </div>
    </div>
  )
}
